export const NO_STATUS_AVAILABLE = 'unavailable' as const;
export const NO_LEAD_AVAILABLE = 'unavailable' as const;
export const NO_LOAN_AVAILABLE = 'unavailable' as const;
